import React from "react";
import locale from "@bonliva-crm/locale";
import Alert from "@material-ui/lab/Alert";
import { makeStyles, Link } from "@material-ui/core";
import { BookingProfileLocation, useNavigation } from "@navigation";

type Props = {
  needSignatureCustomers: string;
  needSignatureTROkInAppCustomers: string;
  noApprovalCustomers: string;
  noApprovalMonthlyCustomers: string;
  noApprovalShortCustomers: string;
  noApprovalSpecialCustomers: string;
  consultantServicePref: React.ReactNode;
  consultantCare: string;
  bookingIntro: string;
  nationalProcurementTravelRequired: string;
  duplicateIds: string[];
};

export function BookingAlerts(props: Props) {
  const { navigate } = useNavigation();
  const classes = useStyles({});

  const items = [];
  // TODO refactor

  if (props.duplicateIds.length > 0) {
    items.push(
      <Alert key={"hasDuplicates"} severity="error" className={classes.error}>
        {locale.BookingHasDuplicates} <br />
        {props.duplicateIds.map((bookingId, i) => {
          return (
            <Link
              href={`/bookings/${bookingId}/finance`}
              onClick={(e) => {
                navigate(new BookingProfileLocation(bookingId));
                e.preventDefault();
              }}
              style={{ marginRight: "15px" }}
            >
              {locale["View duplicate"]} {i + 1}
            </Link>
          );
        })}
      </Alert>
    );
  }

  if (props.needSignatureCustomers) {
    items.push(
      <Alert key={"needSignatureCustomers"} severity="info" className={classes.warning}>
        {props.needSignatureCustomers}
        {locale.NeedConsultantSignature}
      </Alert>
    );
  }

  if (props.needSignatureTROkInAppCustomers) {
    items.push(
      <Alert
        key={"needSignatureTROkInAppCustomers"}
        severity="info"
        className={classes.warning}
      >
        {props.needSignatureTROkInAppCustomers}
        {locale.NeedSignatureTROkInAppCustomers}
      </Alert>
    );
  }

  if (props.noApprovalCustomers) {
    items.push(
      <Alert key={"noApprovalCustomers"} severity="info" className={classes.info}>
        {props.noApprovalCustomers}
        {locale.noNeedApproval}
      </Alert>
    );
  }

  if (props.noApprovalMonthlyCustomers) {
    items.push(
      <Alert key={"noApprovalMonthly"} severity="info" className={classes.info}>
        {props.noApprovalMonthlyCustomers}
        {locale.noApprovalMonthly}
      </Alert>
    );
  }

  if (props.noApprovalShortCustomers) {
    items.push(
      <Alert key={"noApprovalShortening"} severity="info" className={classes.info}>
        {props.noApprovalShortCustomers}
        {locale.noApprovalShortening}
      </Alert>
    );
  }

  if (props.noApprovalSpecialCustomers) {
    items.push(
      <Alert key={"noApprovalSpecial"} severity="info" className={classes.info}>
        {props.noApprovalSpecialCustomers}
        {locale.noApprovalSpecial}
      </Alert>
    );
  }

  if (props.consultantServicePref) {
    items.push(props.consultantServicePref);
  }

  if (props.consultantCare) {
    items.push(
      <Alert key={"consultantCare"} severity="info" className={classes.info}>
        <span style={{ color: "#521e1e", whiteSpace: "pre-line" }}>
          <span style={{ fontWeight: "bold" }}>{locale.consultantCare}: </span>
          {props.consultantCare}
        </span>
      </Alert>
    );
  }

  if (props.bookingIntro) {
    items.push(
      <Alert key={"bookingIntro"} severity="info" className={classes.warning}>
        <span style={{ color: "#521e1e" }}>
          <span style={{ fontWeight: "bold" }}>OBS introduktion första veckan. </span>
          {props.bookingIntro}
        </span>
      </Alert>
    );
  }

  if (props.nationalProcurementTravelRequired) {
    items.push(
      <Alert key={"noApprovalSpecial"} severity="info" className={classes.info}>
        <span style={{ fontWeight: "bold" }}>Fakturering för resa är möjlig: </span>
        {props.nationalProcurementTravelRequired}
      </Alert>
    );
  }

  return items.length > 0 ? <div>{items}</div> : null;
}

const useStyles = makeStyles(() => ({
  info: {
    borderRadius: 0,
    color: "#0d3c61",
    backgroundColor: "#e8f4fd",

    "& svg": {
      color: "#0d3c61"
    }
  },

  warning: {
    borderRadius: 0,
    color: "#663c00",
    backgroundColor: "#fff4e5",

    "& svg": {
      color: "#ff9800"
    }
  },

  error: {
    borderRadius: 0,
    color: "#721c24",
    backgroundColor: "#f8d7da",

    "& svg": {
      color: "#dc3545"
    }
  }
}));
